import type { PlacementGroup } from '@/modules/adv/ad-service'
import { type AdProvidersSettings, type AdSenseProviderSettings, AdProviderTypes, type PlatformType } from '@/types'

import { DEFAULT_AD_UNIT_TIMEOUT } from './constants'

const AD_SENSE_PORTAL_CLIENT_ID = 'ca-pub-2864899775153797'
const STATIC_GOOGLE_AD_SENSE_UNITS: Record<string, string> = {
    sticky_mobile: '2256255959',
    sticky_desktop: '2256255959',
}

export const getOppoAdSettings = (
    isAdDisabled: boolean | undefined,
    platform: PlatformType,
): PlacementGroup<AdProvidersSettings>[] =>
    isAdDisabled
        ? []
        : [
              {
                  placements: ['*'],
                  settings: [
                      {
                          type: AdProviderTypes.GOOGLE_AD_SENSE,
                          options: {
                              platform,
                              clientId: AD_SENSE_PORTAL_CLIENT_ID,
                              timeout: DEFAULT_AD_UNIT_TIMEOUT,
                              adUnitConfig: {
                                  desktop: STATIC_GOOGLE_AD_SENSE_UNITS,
                                  mobile: STATIC_GOOGLE_AD_SENSE_UNITS,
                              },
                              targeting: {
                                  exp: '5883774659', // = channel group_control
                              },
                          },
                      } satisfies AdSenseProviderSettings,
                  ],
              },
          ]
